import { fancyInit } from './components/fancybox';
import { isotopeInit } from './components/isotope';
import { flickityInit } from './components/flickity';
import { socialSharing } from './components/sharesocial';
import { readTiming } from './components/readtiming';
import { responsiveEmbeds } from './components/responsiveembeds';
import { tabPanel } from './components/tabPanel';

fancyInit();
isotopeInit();
flickityInit();
socialSharing();
readTiming();
responsiveEmbeds();
tabPanel();

